import { render, staticRenderFns } from "./BlogLinkContainer.vue?vue&type=template&id=4416037f&scoped=true"
import script from "./BlogLinkContainer.vue?vue&type=script&lang=ts"
export * from "./BlogLinkContainer.vue?vue&type=script&lang=ts"
import style0 from "./BlogLinkContainer.vue?vue&type=style&index=0&id=4416037f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416037f",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/blog-link-container.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FBlogLinkContainer.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports